require('./prtv-interface-2.scss');

import DemandeActions from '../../../../actions/demande.actions';

import { STEPS } from '../../../../utils/routes.util';

export default class PrtvInterface2Component {
  constructor() {
    this.controller = PrtvInterface2Controller;
    this.template = require('./prtv-interface-2.html');
  }
}

// @ngInject
class PrtvInterface2Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.PRTV_INTERFACE_2));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier :
            state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          data: state.demande.data.prtvInterface2 ? state.demande.data.prtvInterface2.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
        };
      }
    )(this);
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
    this.disableNext = true;
    this.prerequis = {antenne: false , voisins: false};
  }

  onPrerequisChange(prerequis) {
    this.disableNext = prerequis.antenne && prerequis.voisins === true ? false : true ;
  }
  // Actions
  nextStep() {
    this.data.demandeEnquetePapier = this.demandeEnquetePapier;
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface2(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/prtv/components/prtv-interface-2/prtv-interface-2.component.js